import { useMemo } from 'react';
import { PanelDimensions } from 'src/types/ViewModel/Stowage/PanelDimensions';
import { Position } from 'src/types/ViewModel/Stowage/Position';

/**
 * Hook to calculate optimal position for an element based on a click position
 * Ensures the element is fully visible within the viewport
 */
export const usePositionFromClick = (clickPosition: Position | null, options: PanelDimensions): Position => {
    return useMemo(() => {
        // Default position at top-left corner
        const defaultPosition: Position = { top: 0, left: 0 };

        if (!clickPosition) return defaultPosition;

        // Start with the click position
        const position: Position = { ...clickPosition };

        const { width, height, padding = 0 } = options;

        // Get viewport dimensions
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Check and adjust horizontal position
        if (position.left + width + padding > viewportWidth) {
            position.left = position.left - width - padding;
        }

        // Check and adjust vertical position
        if (position.top + height + padding > viewportHeight) {
            position.top = position.top - height - padding;
        }

        // Ensure the position is not negative
        position.left = Math.max(padding, position.left);
        position.top = Math.max(padding, position.top);

        return position;
    }, [clickPosition, options.width, options.height, options.padding]);
};
